// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_votesHeader__z2407 {
  display: flex;
  align-items: center;
  gap: 0.75rem; }

.styles_header__VZuHF {
  width: unset;
  padding-top: 0.5rem;
  margin-bottom: 1rem;
  opacity: 0.5; }
  .styles_header__VZuHF h2 {
    color: #808080e6; }

.styles_countButton__H7GJq {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  transition: opacity 0.2s ease; }
  .styles_countButton__H7GJq:hover:not(:disabled) {
    opacity: 0.7; }
  .styles_countButton__H7GJq:disabled {
    cursor: default; }

.styles_countText__9Ws1m {
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 500; }

.styles_actionButton__DvL6B {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease; }
  .styles_actionButton__DvL6B:hover {
    background-color: rgba(0, 0, 0, 0.05); }
  .styles_actionButton__DvL6B:active {
    background-color: rgba(0, 0, 0, 0.1); }

.styles_actionIcon__b0C62 {
  font-size: 1.125rem;
  line-height: 1; }

.styles_votesModal__3JNFC {
  max-width: 37.5rem;
  width: 90vw;
  max-height: 70vh;
  overflow: hidden;
  display: flex;
  flex-direction: column; }

.styles_votesModalList__aoM-j {
  flex: 1 1;
  overflow-y: auto;
  padding: 1rem 0; }
  .styles_votesModalList__aoM-j .styles_voteItem__tXtTo {
    margin-bottom: 1rem; }
    .styles_votesModalList__aoM-j .styles_voteItem__tXtTo:last-child {
      margin-bottom: 0; }

.styles_voteItem__tXtTo {
  margin: 0.5rem 1rem;
  padding: 0.75rem;
  margin-bottom: 0.5rem;
  border-radius: 0.5rem;
  border: 0.0625rem solid rgba(76, 175, 80, 0.2);
  box-shadow: 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.2s ease; }
  .styles_voteItem__tXtTo.styles_positive__ZXMIP {
    background-color: rgba(76, 175, 80, 0.05);
    border-color: rgba(76, 175, 80, 0.2); }
    .styles_voteItem__tXtTo.styles_positive__ZXMIP .styles_voteScoreText__1c9Wq {
      color: #4caf50; }
    .styles_voteItem__tXtTo.styles_positive__ZXMIP .styles_voteScore__mIK5j {
      background-color: rgba(76, 175, 80, 0.2); }
  .styles_voteItem__tXtTo.styles_negative__ulBwM {
    background-color: rgba(244, 67, 54, 0.05);
    border-color: rgba(244, 67, 54, 0.2); }
    .styles_voteItem__tXtTo.styles_negative__ulBwM .styles_voteScoreText__1c9Wq {
      color: #f44336; }
    .styles_voteItem__tXtTo.styles_negative__ulBwM .styles_voteScore__mIK5j {
      background-color: rgba(244, 67, 54, 0.2); }
  .styles_voteItem__tXtTo:hover {
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.08); }
  .styles_voteItem__tXtTo:last-child {
    margin-bottom: 0; }

.styles_voteContent__c5qHp {
  display: flex;
  flex-direction: column;
  gap: 0.5rem; }

.styles_voteHeader__8nxmj {
  display: flex;
  align-items: center;
  justify-content: space-between; }

.styles_voteAuthor__-BZi4 {
  font-weight: 700;
  color: rgba(0, 0, 0, 0.8); }

.styles_voteScore__mIK5j {
  border-radius: 1rem;
  padding: 0.25rem 0.5rem; }

.styles_voteScoreText__1c9Wq {
  font-size: 0.75rem;
  font-weight: 600;
  color: #1b5e20; }

.styles_voteText__X3SLr {
  font-size: 0.875rem;
  line-height: 1.4; }

@media (max-width: 48rem) {
  .styles_votesHeader__z2407 {
    gap: 0.5rem; }
  .styles_voteItem__tXtTo {
    padding: 0.625rem; }
  .styles_countText__9Ws1m {
    font-size: 0.8125rem; }
  .styles_actionIcon__b0C62 {
    font-size: 1rem; } }
`, "",{"version":3,"sources":["webpack://./src/modules/teachings/components/TeachingVotesSection/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY,EAAA;;AAGd;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY,EAAA;EAJd;IAOI,gBCGc,EAAA;;ADClB;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,6BAA6B,EAAA;EAL/B;IAQI,YAAY,EAAA;EARhB;IAYI,eAAe,EAAA;;AAInB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC,EAAA;EATxC;IAYI,qCAAqC,EAAA;EAZzC;IAgBI,oCAAoC,EAAA;;AAIxC;EACE,mBAAmB;EACnB,cAAc,EAAA;;AAIhB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB,EAAA;;AAGxB;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe,EAAA;EAHjB;IAMI,mBAAmB,EAAA;IANvB;MASM,gBAAgB,EAAA;;AAMtB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EAuBrB,qBAAqB;EACrB,8CAA8C;EAC9C,oDAAoD;EACpD,gCAAgC,EAAA;EA7BlC;IAKI,yCAAyC;IACzC,oCAAoC,EAAA;IANxC;MAQM,cAA2B,EAAA;IARjC;MAWM,wCAAwC,EAAA;EAX9C;IAgBI,yCAAyC;IACzC,oCAAoC,EAAA;IAjBxC;MAmBM,cAA2B,EAAA;IAnBjC;MAsBM,wCAAwC,EAAA;EAtB9C;IAgCI,kDAAkD,EAAA;EAhCtD;IAoCI,gBAAgB,EAAA;;AAIpB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B,EAAA;;AAGhC;EACE,gBAAgB;EAChB,yBAAyB,EAAA;;AAG3B;EACE,mBAAmB;EACnB,uBAAuB,EAAA;;AAGzB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAA0B,EAAA;;AAG5B;EACE,mBAAmB;EACnB,gBAAgB,EAAA;;AAIlB;EACE;IACE,WAAW,EAAA;EAGb;IACE,iBAAiB,EAAA;EAGnB;IACE,oBAAoB,EAAA;EAGtB;IACE,eAAe,EAAA,EAChB","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.votesHeader {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.header {\n  width: unset;\n  padding-top: 0.5rem;\n  margin-bottom: 1rem;\n  opacity: 0.5;\n\n  h2 {\n    color: $grey90;\n  }\n}\n\n.countButton {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n\n  &:hover:not(:disabled) {\n    opacity: 0.7;\n  }\n\n  &:disabled {\n    cursor: default;\n  }\n}\n\n.countText {\n  font-size: 0.875rem;\n  color: rgba(0, 0, 0, 0.6);\n  font-weight: 500;\n}\n\n.actionButton {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s ease;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n  }\n\n  &:active {\n    background-color: rgba(0, 0, 0, 0.1);\n  }\n}\n\n.actionIcon {\n  font-size: 1.125rem;\n  line-height: 1;\n}\n\n// Votes Modal Styles\n.votesModal {\n  max-width: 37.5rem;\n  width: 90vw;\n  max-height: 70vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.votesModalList {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1rem 0;\n\n  .voteItem {\n    margin-bottom: 1rem;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n}\n\n// Individual Vote Styles\n.voteItem {\n  margin: 0.5rem 1rem;\n  padding: 0.75rem;\n  margin-bottom: 0.5rem;\n  &.positive {\n    background-color: rgba(76, 175, 80, 0.05);\n    border-color: rgba(76, 175, 80, 0.2);\n    .voteScoreText {\n      color: rgba(76, 175, 80, 1);\n    }\n    .voteScore {\n      background-color: rgba(76, 175, 80, 0.2);\n    }\n  }\n\n  &.negative {\n    background-color: rgba(244, 67, 54, 0.05);\n    border-color: rgba(244, 67, 54, 0.2);\n    .voteScoreText {\n      color: rgba(244, 67, 54, 1);\n    }\n    .voteScore {\n      background-color: rgba(244, 67, 54, 0.2);\n    }\n  }\n\n  border-radius: 0.5rem;\n  border: 0.0625rem solid rgba(76, 175, 80, 0.2);\n  box-shadow: 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.04);\n  transition: box-shadow 0.2s ease;\n\n  &:hover {\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.08);\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.voteContent {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.voteHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.voteAuthor {\n  font-weight: 700;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.voteScore {\n  border-radius: 1rem;\n  padding: 0.25rem 0.5rem;\n}\n\n.voteScoreText {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: rgba(27, 94, 32, 1);\n}\n\n.voteText {\n  font-size: 0.875rem;\n  line-height: 1.4;\n}\n\n// Responsive adjustments\n@media (max-width: 48rem) {\n  .votesHeader {\n    gap: 0.5rem;\n  }\n\n  .voteItem {\n    padding: 0.625rem;\n  }\n\n  .countText {\n    font-size: 0.8125rem;\n  }\n\n  .actionIcon {\n    font-size: 1rem;\n  }\n}","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"votesHeader": `styles_votesHeader__z2407`,
	"header": `styles_header__VZuHF`,
	"countButton": `styles_countButton__H7GJq`,
	"countText": `styles_countText__9Ws1m`,
	"actionButton": `styles_actionButton__DvL6B`,
	"actionIcon": `styles_actionIcon__b0C62`,
	"votesModal": `styles_votesModal__3JNFC`,
	"votesModalList": `styles_votesModalList__aoM-j`,
	"voteItem": `styles_voteItem__tXtTo`,
	"positive": `styles_positive__ZXMIP`,
	"voteScoreText": `styles_voteScoreText__1c9Wq`,
	"voteScore": `styles_voteScore__mIK5j`,
	"negative": `styles_negative__ulBwM`,
	"voteContent": `styles_voteContent__c5qHp`,
	"voteHeader": `styles_voteHeader__8nxmj`,
	"voteAuthor": `styles_voteAuthor__-BZi4`,
	"voteText": `styles_voteText__X3SLr`
};
export default ___CSS_LOADER_EXPORT___;
